import * as onboardingRoutes from 'src/app/onboarding/routes';

/**
 * If user is in the growth-show-self-serve-scale-ui flag, use the self-serve upgrade route/button text.
 * Otherwise, use the legacy upgrade route/button text.
 */
export const useUpgradeContext = () => {
  return {
    upgradeRoute: onboardingRoutes.selectPlan.path({
      type: 'upgrade',
    }),
    upgradeButtonText: 'Change plan',
  };
};
